<template>
  <form id="caregiverInfo2" @submit.prevent="save()">
    <div class="px-4 lg:col-span-12 pt-0">
      <div class="grid grid-cols-6 gap-4">
        <div class="col-span-6 sm:col-span-3">
          <label for="primary_phone" class="block text-gray-700">{{ $t('common.form.primaryPhone') }} <span class="text-gtRed500">*</span></label>
          <div class="mt-1 relative">
            <input
              v-model="caregiverInfo2.phonePrimary"
              @input="acceptNumber"
              required
              oninvalid="this.setCustomValidity('Please match the requested format.')"
              oninput="this.setCustomValidity('')"
              type="tel"
              class="text-gray-800 h-8 mb-1 block w-full bg-white rounded-md surrounding-shadow py-1 px-3 focus:outline-none"
              id="primary_phone"
              pattern="\(\d\d\d\) \d\d\d-\d\d\d\d"
            />
          </div>
        </div>
        <div class="col-span-6 sm:col-span-3">
          <div class="flex justify-between">
            <label for="secondary_phone" class="block text-gray-700">{{ $t('common.form.secondaryPhone') }}</label>
          </div>
          <div class="mt-1 relative">
            <input
              v-model="caregiverInfo2.phoneSecondary"
              oninvalid="this.setCustomValidity('Please match the requested format.')"
              oninput="this.setCustomValidity('')"
              type="tel"
              @input="acceptSecondaryNumber"
              class="text-gray-800 h-8 mb-1 block w-full bg-white rounded-md surrounding-shadow py-1 px-3 focus:outline-none"
              id="secondary_phone"
              pattern="\(\d\d\d\) \d\d\d-\d\d\d\d"
            />
          </div>
        </div>
        <div class="col-span-6 sm:col-span-6">
          <label for="email" class="block text-gray-700">{{ $t('common.form.email') }} <span class="text-gtRed500">*</span></label>
          <div class="mt-1 relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <EnvelopeIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
            </div>
            <input
              v-model="caregiverInfo2.email"
              required
              oninvalid="this.setCustomValidity('Please provide a valid email address.')"
              oninput="this.setCustomValidity('')"
              type="email"
              class="pl-10 text-gray-800 h-8 mb-1 block w-full bg-white rounded-md surrounding-shadow py-1 px-3 focus:outline-none"
              placeholder="email@mail.com"
              id="email"
            />
          </div>
        </div>
        <div class="col-span-6 sm:col-span-6">
          <label for="primary_street_address" class="block text-gray-700">
            {{ $t('common.form.homeAddress') }}
            <span class="text-gtRed500">*</span>
          </label>
          <div class="mt-1 relative">
            <input
              ref="searchPrimary"
              v-model="primaryAddress"
              required
              oninvalid="this.setCustomValidity('Please verify your home address.')"
              oninput="this.setCustomValidity('')"
              type="text"
              class="text-gray-800 h-8 mb-1 block w-full bg-white rounded-md surrounding-shadow py-1 px-3 focus:outline-none"
              placeholder="Enter address"
              id="primary_street_address"
              @keydown.enter.prevent
            />
          </div>
        </div>
        <div class="col-span-6 sm:col-span-6">
          <div class="mt-1 relative flex items-center ">
            <input
              v-model="isMailingAddressSame"
              @change="checkSameMailingAddress()"
              type="checkbox"
              id="is_mailing_address_same"
              class="cursor-pointer"
            />
            <label for="is_mailing_address_same" class="block text-gray-700 ml-4 cursor-pointer">
              {{ $t('common.form.mailingAddressIsSame') }}
            </label>
          </div>
        </div>
        <div class="col-span-6 sm:col-span-6">
          <div class="flex justify-between">
            <label for="alternate_street_address" class="block text-gray-700">
              {{ $t('common.form.mailingAddress') }}
            </label>
          </div>          
          <div class="mt-1 relative">
            <input
              ref="searchSecondary"
              v-model="secondaryAddress"
              type="text"
              oninput="this.setCustomValidity('')"
              @input="handleSecondaryAddressInput"
              class="text-gray-800 h-8 mb-1 block w-full bg-white rounded-md surrounding-shadow py-1 px-3 focus:outline-none"
              placeholder="Enter address"
              id="alternate_street_address"
              @keydown.enter.prevent
            />
          </div>
        </div>
        <div class="col-span-6 sm:col-span-3">
          <label for="county" class="block text-gray-700">{{ $t('common.form.county') }} <span class="text-gtRed500">*</span></label>
          <div class="flex items-center mt-1">
            <input
              v-model="caregiverInfo2.addressPrimary.county"
              required
              oninvalid="this.setCustomValidity('Please enter County.')"
              oninput="this.setCustomValidity('')"
              type="text"
              class="text-gray-800 h-8 mb-1 block w-full bg-white rounded-md surrounding-shadow py-1 px-3 focus:outline-none"
              placeholder="County"
              id="county"
            />
          </div>
        </div>
        <span class="col-span-3 hidden sm:block"></span>
        <div class="col-span-6 sm:col-span-3">
          <label for="language" class="block text-gray-700">
            {{ $t('common.form.preferredLanguage') }}
          </label>
          <div class="flex items-center mt-1">
            <select
              v-model="caregiverInfo2.language"
              id="language"
              name="language"
              @change="changeLanguage()"
              class="text-gray-800 h-8 mb-1 block w-full bg-white rounded-md surrounding-shadow py-1 px-3 focus:outline-none"
            >
            <option :value="null" hidden></option>
              <option v-for="(option, key) in languages" :value="option.name" :key="key">
                {{ option.name }}
              </option>
              <option ref="other_language_option" :value="caregiverInfo2.language">Other</option>
            </select>
          </div>
        </div>
        <div v-if="isOtherLanguage" class="col-span-6 sm:col-span-3">
          <label for="language_other" class="block text-gray-700">
            {{ $t('common.form.preferredLanguage') }}
          </label>
          <div class="flex items-center mt-1">
            <input
              v-model="caregiverInfo2.language"
              id="language_other"
              name="language_other"
              class="text-gray-800 h-8 mb-1 block w-full bg-white rounded-md surrounding-shadow py-1 px-3 focus:outline-none"
            />
          </div>
        </div>
      </div>
    </div>
    <ContinueBackButtons @back="back"></ContinueBackButtons>
  </form>
</template>

<script>
import {EnvelopeIcon} from '@heroicons/vue/20/solid';
import {maskPhoneNumber} from 'Utilities/helper';
import {mask} from 'vue-the-mask';
import addressUtility from 'Utilities/addressUtility';
import ContinueBackButtons from 'Views/Shared/ContinueBackButtons.vue';
import languageService from 'Services/backend/languages';
import { setupDualPostGridAutocomplete } from '@/utilities/autocomplete.js';

export default {
  directives: { mask },
  components: {
    EnvelopeIcon,
    ContinueBackButtons,
  },
  props: ['caregiverData'],
  emits: ['save', 'back', 'loading'],
  data() {
    return {
      counties: '11',
      todayDate: '',
      languages: [],
      isOtherLanguage: false,
      secondaryAddressSuggested: true,
      secondaryAddress: '',
      isMailingAddressSame: false,

      caregiverInfo2: {
        step: 2,
        phonePrimary: '',
        phoneSecondary: '',
        email: '',
        primaryAddress: '',
        alternateAddress: '',
        county: '',
        addressPrimary: {
          addressLine1: '',
          addressLine2: '',
          city: '',
          zipcode: '',
          county: '',
          state: '',
        },
        addressSecondary: {
          addressLine1: '',
          addressLine2: '',
          city: '',
          zipcode: '',
          county: '',
          state: '',
        },
        regionId: 1,
        language: null,
      },
    };
  },
  computed: {
    primaryAddress() {
      const validAddr = this.caregiverInfo2?.addressPrimary;
      return addressUtility.addressToString(validAddr);
    },
  },
  methods: {
    maskPhoneNumber,

    changeLanguage() {
      this.isOtherLanguage = this.$refs['other_language_option']?.selected;
      if (this.isOtherLanguage) this.caregiverInfo2.language = '';
    },

    acceptNumber() {
      this.caregiverInfo2.phonePrimary = maskPhoneNumber(this.caregiverInfo2.phonePrimary);
    },

    acceptSecondaryNumber() {
      this.caregiverInfo2.phoneSecondary = maskPhoneNumber(this.caregiverInfo2.phoneSecondary);
    },

    async save() {
      this.$emit('loading', true);

      if (!this.secondaryAddress.trim().length) this.caregiverInfo2.addressSecondary = {};
      else if (!this.secondaryAddressSuggested) this.caregiverInfo2.addressSecondary = await addressUtility.verifyAddress(this.secondaryAddress);
      
      this.$emit('loading', false);

      if (!this.caregiverInfo2.addressSecondary) {
        this.$refs['searchSecondary'].setCustomValidity('Please verify your mailing address.');
        this.$refs['searchSecondary'].reportValidity();
      } else this.$emit('save', this.caregiverInfo2);
    },

    back() {
      this.$emit('back');
    },
    initPrimaryLocationSearch() {
      setupDualPostGridAutocomplete(
        this.$refs,
        (parsedAddress) => {
          this.caregiverInfo2.addressPrimary = parsedAddress;
          this.checkSameMailingAddress();
        },
        (parsedAddress) => {
          this.caregiverInfo2.addressSecondary = parsedAddress;
          this.secondaryAddress = this.$refs.searchSecondary.value;
          this.secondaryAddressSuggested = true;
        }
      );
    },
    async getLanguages() {
      await languageService.getLanguages().then(
        response => this.languages = response.data.languages,
        error => console.error(error),
      );
    },
    checkSameMailingAddress() {
      if (this.isMailingAddressSame) {
        this.secondaryAddress = this.primaryAddress;
        this.caregiverInfo2.addressSecondary = this.caregiverInfo2.addressPrimary;
        this.secondaryAddressSuggested = true;
      }
    },
    handleSecondaryAddressInput() {
      this.secondaryAddressSuggested = false;
      this.isMailingAddressSame = false;
    },
  },

  watch: {
    caregiverData(newEnrollees) {
      if (newEnrollees) {
        this.caregiverInfo2 = {
          step: 2,
          phonePrimary: newEnrollees.phonePrimary,
          phoneSecondary: newEnrollees.phoneSecondary,
          email: newEnrollees.email,
          primaryAddress: newEnrollees.primaryAddress,
          alternateAddress: newEnrollees.alternateAddress,
          county: newEnrollees.county,
          regionId: 1,
          language: newEnrollees?.language,
          addressPrimary: {
            addressLine1: newEnrollees.addressPrimary.addressLine1,
            addressLine2: newEnrollees.addressPrimary.addressLine2,
            city: newEnrollees.addressPrimary.city,
            zipcode: newEnrollees.addressPrimary.zipcode,
            county: newEnrollees.addressPrimary.county,
            state: newEnrollees.addressPrimary.state,
          },
          addressSecondary: {
            addressLine1: newEnrollees.addressSecondary.addressLine1,
            addressLine2: newEnrollees.addressSecondary.addressLine2,
            city: newEnrollees.addressSecondary.city,
            zipcode: newEnrollees.addressSecondary.zipcode,
            county: newEnrollees.addressSecondary.county,
            state: newEnrollees.addressSecondary.state,
          },
        };
        this.caregiverInfo2.phonePrimary = maskPhoneNumber(this.caregiverInfo2.phonePrimary);
        this.caregiverInfo2.phoneSecondary = maskPhoneNumber(this.caregiverInfo2.phoneSecondary);
      
        this.isOtherLanguage = (this.caregiverInfo2.language && this.languages.filter(lang => lang.name === this.caregiverInfo2.language).length === 0);
        this.secondaryAddress = addressUtility.addressToString(this.caregiverInfo2.addressSecondary);
        this.isMailingAddressSame = JSON.stringify(this.caregiverInfo2.addressPrimary) == JSON.stringify(this.caregiverInfo2.addressSecondary);
      }
    },
  },
  async mounted() {
    this.initPrimaryLocationSearch();
    await this.getLanguages();
  },
};
</script>

<style></style>
